import { render, staticRenderFns } from "./dr-signature-pad.vue?vue&type=template&id=06791a16&"
import script from "./dr-signature-pad.vue?vue&type=script&lang=js&"
export * from "./dr-signature-pad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports